import { Instance, types } from 'mobx-state-tree';
export const CropSummary = types.model('CropSummary', {
  name: types.string,
  name_i18n: types.model({
    en: types.string,
    th: types.maybeNull(types.string),
    ja: types.maybeNull(types.string),
    vi: types.maybeNull(types.string)
  }),
  varieties: types.number,
  area: types.number,
  total_percentage: types.number
});
export type ICropSummary = Instance<typeof CropSummary>;